import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpStatus } from '../../common/enums/HttpStatus';
import { createBaseQuery } from './utils/createBaseQuery';
import { IVersion } from '../../common/interfaces/Version.interface';

export const versionManagmentApi = createApi({
  reducerPath: 'versionManagmentApi',
  baseQuery: createBaseQuery('/application-versions'),
  tagTypes: ['VersionManagment'],
  endpoints: (builder) => ({
    fetchVersions: builder.query<
      { code: HttpStatus; data: IVersion[] },
      { page: number; size: number }
    >({
      query: ({ page, size }) => `?page=${page}&size=${size}`,
      providesTags: (result) =>
        result
          ? [
              { type: 'VersionManagment' as const, id: 'LIST' },
              ...result.data.map(({ id }) => ({
                type: 'VersionManagment' as const,
                id,
              })),
            ]
          : [{ type: 'VersionManagment' as const, id: 'LIST' }],
    }),
    addVersion: builder.mutation<IVersion, Partial<IVersion>>({
      query: (newContent) => ({
        url: '',
        method: 'POST',
        body: newContent,
      }),
      invalidatesTags: [{ type: 'VersionManagment', id: 'LIST' }],
    }),
    updateVersion: builder.mutation<
      IVersion,
      { id: string; updatedContent: Partial<IVersion> }
    >({
      query: ({ id, updatedContent }) => ({
        url: `/${id}`,
        method: 'PATCH',
        body: updatedContent,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'VersionManagment', id },
        { type: 'VersionManagment', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useFetchVersionsQuery,
  useAddVersionMutation,
  useUpdateVersionMutation,
} = versionManagmentApi;
